module.exports = "<div [hidden]=\"hide\">\r\n    <div class=\"loader\">\r\n        <i class=\"glyphicon glyphicon-cog spin\"></i>\r\n        <div>Einen Augenblick...</div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/loader/loader.component.html
// module id = ./src/app/components/shared/loader/loader.component.html
// module chunks = main